import { ReactNode } from "react";

export const APP_NAME = "SAVEZI";
export const APP_TITLE = "Središnji registar sportskih saveza";

export enum Routes {
  HOME = "/",
  ALLIANCES = "/savezi",
  INFO = "/informacije",
  ERRORS = "/greske",
  STATUS = "/status",
  CHANGELOG = "/promjene",
  ALLIANCE_DETAIL = "/savezi/:id",
}

export interface NavLink {
  label: string;
  path: string;
}

export const NAV_LINKS: NavLink[] = [
  { label: "Početna", path: Routes.HOME },
  { label: "Pretraga", path: Routes.ALLIANCES },
  { label: "Informacije", path: Routes.INFO },
  { label: "Greške", path: Routes.ERRORS },
  { label: "Status", path: Routes.STATUS },
  { label: "Promjene", path: Routes.CHANGELOG },
];

/** Matches backend `CoverageField` - order is used in tables. */
export interface CoverageColumnDef {
  key: string;
  label: string;
  shortLabel: string;
  subtitle: string;
  iconName: string;
}

export const COVERAGE_COLUMNS: CoverageColumnDef[] = [
  {
    key: "details",
    label: "Detalji",
    shortLabel: "Det.",
    subtitle: "Naziv, sport, OIB i ostali osnovni podaci",
    iconName: "Info",
  },
  {
    key: "news",
    label: "Vijesti",
    shortLabel: "Vij.",
    subtitle: "RSS i službene objave",
    iconName: "Newspaper",
  },
  {
    key: "members",
    label: "Članovi",
    shortLabel: "Čl.",
    subtitle: "Klubovi, udruge, članstva",
    iconName: "Group",
  },
  {
    key: "documents",
    label: "Dokumenti",
    shortLabel: "Dok.",
    subtitle: "Izvještaji, statuti, akti",
    iconName: "Description",
  },
  {
    key: "schedules",
    label: "Rasporedi",
    shortLabel: "Ras.",
    subtitle: "Natjecanja, termini, kalendar",
    iconName: "CalendarMonth",
  },
  {
    key: "rulebooks",
    label: "Pravilnici",
    shortLabel: "Prav.",
    subtitle: "Službena pravila i propisi",
    iconName: "MenuBook",
  },
  {
    key: "references",
    label: "Reference",
    shortLabel: "Ref.",
    subtitle: "Vanjske poveznice",
    iconName: "Link",
  },
  {
    key: "about",
    label: "O savezu",
    shortLabel: "O s.",
    subtitle: "Tekstualni opis i prezentacija",
    iconName: "Article",
  },
  {
    key: "contact",
    label: "Kontakt",
    shortLabel: "Kon.",
    subtitle: "E-mail, telefon i kontakt osobe",
    iconName: "ContactMail",
  },
  {
    key: "address",
    label: "Adresa",
    shortLabel: "Adr.",
    subtitle: "Sjedište, grad, županija",
    iconName: "LocationOn",
  },
  {
    key: "other",
    label: "Ostalo",
    shortLabel: "Ost.",
    subtitle:
      "Ostale informacije (OIB, IBAN, dodatna polja prikupljenih podataka)",
    iconName: "Notes",
  },
];

export const NAVBAR_HEIGHT = 64;

/** Veza na Pinehood Bug Reporter (samo hrvatski, bez i18n). */
export const REPORT_BUG_LABEL = "Prijavi problem";

export const PAGE_SIZE_ALLIANCES = 12;
export const PAGE_SIZE_NEWS = 20;
export const PAGE_SIZE_DOCUMENTS = 30;
export const PAGE_SIZE_ERRORS_SUMMARY = 20;
export const PAGE_SIZE_ERRORS_EVENTS = 20;

/** Client-side only: paginirani popisi na stranici pojedinog saveza. */
export const ALLIANCE_DETAIL_LIST_PAGE_SIZE = 25;

export const ABOUT_CONTENT_MAX_LENGTH = 2000;
